import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // find all elements with scrollable overflow
    const allElements = document.querySelectorAll("*");
    allElements.forEach((el) => {
      const style = window.getComputedStyle(el);
      const overflowY = style.getPropertyValue("overflow-y");
      if (overflowY === "auto" || overflowY === "scroll") {
        el.scrollTo({ top: 0 });
      }
    });

    // always scroll window too, just in case
    window.scrollTo({ top: 0});
  }, [pathname]);

  return null;
};

export default ScrollToTop;
